<div class="container">
    <h2>
        404 - Page not found
    </h2>
    <p>You might want to go to the <a routerLink="/home" >Home page</a></p>    
</div>